const TaskFile = React.memo(function TaskFile(props){
    const {
        onChange,
    } = props;

    const [loading, setLoading] = React.useState(false);
    const [progress, setProgress] = React.useState(0);
    const [files, setFiles] = React.useState([]);
    const dropZoneRef = React.useRef(null);
    const uploadFieldRef = React.useRef(null);

    const removeFile = React.useCallback(id => event => {
        event.preventDefault();
        setFiles(currentFiles => {
            let files = _.clone(currentFiles);
            _.remove(files, file => {
                return file.id === id;
            });
            return files;
        });
    }, []);

    React.useEffect(() => {
        let filenames = [];
        let tempFilenames = [];
        _.each(files, file => {
            if(file.success === true){
                filenames.push(file.name);
                tempFilenames.push(file.tmpName);
            }
        });
        onChange('filename', filenames);
        onChange('temp_filename', tempFilenames);
    }, [files]);

    React.useEffect(() => {
        $(uploadFieldRef.current).fileupload({
            url: SS.route('People', 'PersonFiles', 'uploadFile', null),
            dataType: 'json',
            dropZone: $(dropZoneRef.current),
            singleFileUploads: true,
            previewThumbnail: false,
            formData: {
                "_Token[key]": SS.csrfToken
            },
            send: function (e, data) {
                if(!/^[A-Za-z0-9.\-_]*$/.test(data.files[0].name)){
                    data.preuploadErrorThrown = 'File name contains one or more invalid characters. Only use letters, numbers, dashes and underscores!';
                    setLoading(false);
                    return false;
                }
            }
        }).on('fileuploaddrop', (event, data) => {
            setFiles(currentFiles => {
                let files = _.clone(currentFiles);
                _.each(data.files, file => {
                    let id = file.name;
                    let fileIndex = _.findIndex(files, {'id': id});
                    if(fileIndex >= 0){
                        _.assign(files[fileIndex], {tmpPath: null, tmpFolder: null, success: null, error: false});
                    }else{
                        files.push({id: id, tmpPath: null, tmpFolder: null, success: null, error: false});
                    }
                });
                return files;
            });
            setProgress(0);
            setLoading(true);
        }).on('fileuploadchange', (event, data) => {
            setFiles(currentFiles => {
                let files = _.clone(currentFiles);
                _.each(data.files, file => {
                    let id = file.name;
                    let fileIndex = _.findIndex(files, {'id': id});
                    if(fileIndex >= 0){
                        _.assign(files[fileIndex], {name: null, tmpName: null, success: null, error: false});
                    }else{
                        files.push({id: id, name: null, tmpName: null, success: null, error: false});
                    }
                });
                return files;
            });
            setProgress(0);
            setLoading(true);
        }).on('fileuploadprogressall', (event, data) => {
            let progress = parseInt(data.loaded / data.total * 100, 10);
            setProgress(progress);
            if(progress === 100){
                setLoading(false);
                setTimeout(() => {
                    setProgress(0);
                }, 500);
            }
        }).on('fileuploaddone', (event, data) => {
            setFiles(currentFiles => {
                let files = _.clone(currentFiles);
                let id = _.get(data, 'files[0].name', null);
                let name = _.get(data, 'result.data.fileName', '');
                let tmpName = _.get(data, 'result.data.name', '');
                let fileIndex = _.findIndex(files, {'id': id});
                _.assign(files[fileIndex], {name: name, tmpName: tmpName, success: true, error: false});
                return files;
            });
        }).on('fileuploadfail', (event, data) => {
            setFiles(currentFiles => {
                let files = _.clone(currentFiles);
                let id = _.get(data, 'files[0].name');
                let error = _.get(data, 'preuploadErrorThrown', false);
                if(!error) {
                    error = _.get(data, 'jqXHR.responseJSON.message', false);
                }
                if(!error) {
                    error = _.get(data, 'errorThrown', 'File not uploaded');
                }
                let fileIndex = _.findIndex(files, ['id', id]);
                _.assign(files[fileIndex], {success: false, error});
                return files;
            });
        });
    }, []);

    //useRenderDebug('TaskFile', {props, loading, progress, files});

    return (
        <div className={`processes-task-file flex-vertical`}>
            <div className={`drop-zone ${loading ? 'loading' : ''} ${!props.valid ? 'invalid' : ''}`} ref={dropZoneRef}>
                <div className={'drop-zone-label'}>
                    Upload Files
                    <span>Drag & Drop File(s) or Click Browse</span>
                </div>
                <div className={'drop-zone-button'}>
                    <input type={'button'} className={'upload-button'} value={'Browse'}/>
                    <input type={'file'} ref={uploadFieldRef} className={'upload-field'} name={'files'} multiple={'multiple'}/>
                </div>
                <div className={`progress ${Boolean(loading && progress > 0) ? 'visible' : ''}`}>
                    <div className="progress-inner" style={{width: `${progress}%`}}>{progress}%</div>
                </div>
            </div>
            {Boolean(_.size(files)) &&
                <div className={'files'}>
                    {files.map(file => {
                        return (
                            <div className={'file'}>
                                <div className={'info'}>
                                    {file.success === null && <i className={'fa fa-circle-o-notch fa-spin'}/>}
                                    {file.success === true && <i className={'fa fa-check-circle success'}/>}
                                    {file.success === false && <i className={'fa fa-exclamation-circle error'}/>}
                                    <div className={'name'}>{file.id}</div>
                                    <button type={'button'} className={'remove'} onClick={removeFile(file.id)}>Remove</button>
                                </div>
                                {Boolean(_.size(file.error)) && <div className={'error'}>{file.error}</div>}
                            </div>
                        );
                    })}
                </div>
            }
        </div>
    );
});

TaskFile.defaultProps = {
    onChange: PropTypes.func,
    valid: PropTypes.bool,
};

TaskFile.defaultProps = {
    valid: true,
    onChange: (path, value) => {},
};
TaskFile.displayName = 'TaskFile';